export type BadRequestErrorsBody = { errors?: string[] };

/** First server `errors[]` entry that has an i18n key under `login.two-factor.codes.*`, else null. */
export function pickTranslatedAuthError(responseData: unknown, tError: (key: string) => string): string | null {
  if (!responseData || typeof responseData !== "object") {
    return null;
  }
  const errs = (responseData as BadRequestErrorsBody).errors;
  if (!Array.isArray(errs)) {
    return null;
  }
  for (const code of errs) {
    if (typeof code !== "string") {
      continue;
    }
    const key = `login.two-factor.codes.${code}`;
    const msg = tError(key);
    if (msg !== key) {
      return msg;
    }
  }
  return null;
}
